import { ReportingControllerBaseConfig } from '../../../base';
import { SnippetDetailController } from './snippetDetailInterface';
import { SnippetDetailViewProps } from './snippetDetailProps';

export function createSnippetDetailController(
    config: ReportingControllerBaseConfig
): SnippetDetailController {
    const {
        kernel: {
            provider: { createFormController },
        },
    } = config;

    const formController = createFormController();

    return {
        useProps(context, item, props): SnippetDetailViewProps {
            const form = formController.useProps(props.form);
            return {
                id: item.snippet.id,
                content: item.snippet.content,
                textarea: {
                    value: props.field.content.value,
                    onChange(event) {
                        props.field.content.onChange(event.target.value);
                    },
                },
                submit: {
                    label: 'Update snippet',
                    button: {
                        isLoading: form.form.formState.isSubmitting,
                        onClick: form.form.handleSubmit(props.form.onSubmit),
                    },
                },
                cancel: props.onCancel
                    ? {
                          label: 'Cancel',
                          button: {
                              onClick: props.onCancel,
                          },
                      }
                    : null,
            };
        },
    };
}
